import React, { ChangeEvent, useEffect, useState } from "react";
import { Table, Button, Space, Image, Input, QRCode, Spin, Checkbox } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { svg } from "../../../Assets/svg";
import AddAssetModal from "./Components/Modals/CreateAssetModal";
import { RootState, useAppDispatch } from "../../../store";
import { GetAssetsAPI, GetAssetsCategoryAPI } from "../../Redux/MasterData/assets";
import { useSelector } from "react-redux";
import { render } from "@testing-library/react";
import { AccessiblePermission, API_URL, Image_URL, useDebounce } from "../../../helpers/utils";
import { GetAssetsParams, GetConsumableParams } from "../../Types/state/masterdata";
// import DeleteAssetsModal from "./Components/Modals/DeleteAssetModal";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  DeleteConsumableAPI,
  DownloadConsumablesCsvFileAPI,
  GetConsumableAPI,
  PermanaentDeleteConsumableAPI,
  RestoreConsumableAPI,
} from "../../Redux/MasterData/consumables";
import CommonDeleteModal from "../../Components/Model/CommonDeleteModal";
import CommonRestoreModal from "../../Components/Model/CommonRestoreModal";
import { FullScreenLoader, NoDataMessage } from "../../../Components/Components";
import { BackButton } from "../../Components";
// import DeleteMaterilaModal from "./Components/Modals/DeleteMaterilaModal";

const DeletedConsumables: React.FC = () => {
  const dispatch = useAppDispatch();

  //redux states
  const { consumables, consumablesCount } = useSelector((state: RootState) => state.consumables);
  const { user }: any = useSelector((state: RootState) => state.auth);
  // const
  const Permissions = user?.role?.permission?.find((per: any) => per.name == "Master Data");
  const roleName = user?.role?.name;
  const USER_PERMISSIONS = AccessiblePermission(roleName, Permissions?.access);

  const { deleteConsumablesLoading, getConsumablesLoading, restoreConsumablesLoading, authLoading } = useSelector(
    (state: RootState) => state?.loading
  );

  // initial api call states
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");
  const limit: number = 25;
  const [hasMore, setHasMore] = useState<boolean>(true);
  const debouncedSearch = useDebounce(search, 300);
  const [sorterState, setSorterState] = useState<{
    field: string | null;
    order: "ascend" | "descend" | null;
  }>({
    field: null,
    order: null,
  });

  //other state
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isEditConsumable, setIsEditConsumable] = useState<any>({});
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [isDeleteId, setIsDeleteId] = useState<any>(null);
  const [isRestoreId, setIsRestoreId] = useState(null);
  const [isRestoreModal, setIsRestoreModal] = useState(false);

  //api calls
  const consumableGetPayload: GetConsumableParams = {
    page: currentPage,
    limit: limit,
    search: debouncedSearch,
    start_date: "",
    end_date: "",
    is_active: 2,
    order: sorterState?.field ? `${sorterState?.field} | ${sorterState?.order == "ascend" ? "asc" : "desc"}` : "",
  };

  useEffect(() => {
    dispatch(GetConsumableAPI(consumableGetPayload, setHasMore));
  }, [currentPage, debouncedSearch, sorterState]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    if (sorter.order) {
      setSorterState({ field: sorter.field, order: sorter.order }); // Store sorter state
    } else {
      setSorterState({ field: null, order: null });
    }
    setCurrentPage(1);
  };

  const columns = [
    {
      title: "Consumable Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortOrder: sorterState.field === "name" ? sorterState.order : null, // Keep arrow selected
      render: (name: string) => (name ? name : "-"),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      sorter: true,
      sortOrder: sorterState.field === "qty" ? sorterState.order : null, // Keep arrow selected
      render: (qty: string) => (qty ? qty : "-"),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      sorter: true,
      sortOrder: sorterState.field === "unit" ? sorterState.order : null, // Keep arrow selected
      render: (unit: string) => (unit ? unit : "-"),
    },
    {
      title: "Unit Cost",
      dataIndex: "unit_cost",
      key: "unit_cost",
      sorter: true,
      sortOrder: sorterState.field === "unit_cost" ? sorterState.order : null, // Keep arrow selected
      render: (unit_cost: string) => (unit_cost ? `$${unit_cost}` : "-"),
    },
    {
      title: "Markup",
      dataIndex: "markup",
      key: "markup",
      sorter: true,
      sortOrder: sorterState.field === "markup" ? sorterState.order : null, // Keep arrow selected
      render: (markup: string) => (markup ? `${markup}%` : "-"),
    },
    {
      title: "",
      key: "actions",
      render: (_: any, record: any) => {
        return (
          <div className="d-flex align-items-center gap-2">
            {USER_PERMISSIONS.EDIT && (
              <a
                title="Restore"
                className="tableActionBtn edit-btn"
                onClick={() => {
                  setIsRestoreId(record._id);
                  setIsRestoreModal(true);
                }}
              >
                {svg.restoreIcon}
              </a>
            )}
            {USER_PERMISSIONS.DELETE && (
              <a
                title="Delete"
                className="tableActionBtn delete-btn"
                onClick={() => {
                  setIsDeleteModal(true);
                  setIsDeleteId(record._id);
                }}
              >
                {svg.tableDataDelete}
              </a>
            )}
          </div>
        );
      },
    },
  ];
  const handleDeleteConsumables = () => {
    const onClose = () => {
      setIsDeleteModal(false);
      setIsDeleteId(null);
    };
    const payload: any = {
      id: isDeleteId,
    };

    dispatch(PermanaentDeleteConsumableAPI(payload, onClose, consumableGetPayload));
  };
  const onCloseRestoreModal = () => {
    setIsRestoreModal(false);
    setIsRestoreId(null);
  };
  const handleRestoreConsumable = () => {
    const payload: any = {
      id: isRestoreId,
    };
    dispatch(RestoreConsumableAPI(payload, onCloseRestoreModal, consumableGetPayload));
  };

  const hanldeExportData = () => {
    if (consumables?.length == 0) {
      return;
    }
    const exportDataPayload = {
      page: 1,
      limit: consumablesCount,
      is_active: 2,
      export_data: 1,
      filename: "deleted_consumables",
    };
    dispatch(DownloadConsumablesCsvFileAPI(exportDataPayload));
  };

  return authLoading ? (
    <FullScreenLoader />
  ) : USER_PERMISSIONS?.READ ? (
    <div className="py-3 px-40 d-flex flex-column flex-fill overflow-hidden">
      <div className="d-flex flex-wrap gap-3 justify-content-between mb-4">
        <div className="d-flex gap-2 ">
          <BackButton />
          <h1 className="fw-bold admin-page-title mb-0">Deleted Consumables</h1>
        </div>
        <div className="d-flex flex-wrap gap-3">
          <div className="page-search w-100">
            <Input
              size="large"
              placeholder="Search"
              suffix={svg.search}
              value={search}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                const value = e.target.value?.trim();
                setSearch(value === "" ? "" : e.target.value);
                setCurrentPage(1);
              }}
              className=""
              allowClear
            />
          </div>
          <a className="svg-btn svg-46 svg-secondary" onClick={hanldeExportData}>
            {svg.shareBtnIcon}
          </a>
        </div>
      </div>
      <div className="card border-0 shadow rounded-4 flex-fill overflow-y-auto">
        <div className="card-body overflow-y-auto">
          {getConsumablesLoading && currentPage === 1 ? (
            <FullScreenLoader />
          ) : consumables.length === 0 ? (
            <NoDataMessage text="You do not have any deleted consumables yet." icon={svg?.masterdataNoData} />
          ) : (
            <InfiniteScroll
              dataLength={consumables.length}
              next={() => setCurrentPage((prevPage) => prevPage + 1)}
              hasMore={hasMore}
              loader={
                <div className="text-center">
                  <Spin tip="Loading..." />
                </div>
              }
              height={"100%"}
              style={{
                overflow: "auto",
              }}
            >
              <Table
                dataSource={consumables}
                columns={columns}
                pagination={false}
                scroll={{ x: "1520" }}
                onChange={handleTableChange}
                className="custom-table"
              />
            </InfiniteScroll>
          )}
        </div>
      </div>
      <CommonDeleteModal
        visible={isDeleteModal}
        setIsModalVisible={setIsDeleteModal}
        handleDelete={handleDeleteConsumables}
        setIsDeleteId={setIsDeleteId}
        title={"Permanent Delete Consumable, Are You Sure?"}
        description={
          "This action is permanent and cannot be undone. All associated data and settings will be permanently lost."
        }
        isLoading={deleteConsumablesLoading}
      />
      <CommonRestoreModal
        visible={isRestoreModal}
        setIsModalVisible={setIsRestoreModal}
        handleRestore={handleRestoreConsumable}
        title={"Restore Consumable, Are You Sure?"}
        description={"Restoring this consumable will reinstate all associated data and settings."}
        setIsRestoreId={setIsRestoreId}
        isLoading={restoreConsumablesLoading}
      />
    </div>
  ) : (
    <div className="d-flex flex-column justify-content-center align-items-center text-center h-100">
      {/* <span className="svg-80 mb-4">{icons.emptyUser}</span> */}
      <p className="fs-6 text-black mb-4">You do not have access...</p>
    </div>
  );
};

export default DeletedConsumables;
